import axios from "axios"
import { PLANNER_TAG } from "src/configuration"
import env from "src/env"

const { REACT_APP_REPORT_SERVICE_URL } = env
const REPORT_TEMPLATES_URL = `${REACT_APP_REPORT_SERVICE_URL}/qs/objects/template/byFilter`
const PAGE = 1
const HUGE_PER_PAGE = 1000

const getTemplatesList = (token, handlerGetList) => {
  axios({
    method: `POST`,
    url: `${REPORT_TEMPLATES_URL}?token=${token}&page=${PAGE}&perPage=${HUGE_PER_PAGE}`,
    data: {
      sorting: [{ code: `createDate`, direction: `DESC` }],
      filter: {
        type: `CONTAINS`,
        left: { type: `COMMON_ATTRIBUTE`, attribute: `tags` },
        right: {
          type: `constant`,
          dataType: { type: `TEXT` },
          value: [PLANNER_TAG],
        },
      },
    },
  })
    .then(response => {
      handlerGetList({ status: `completed`, data: response.data })
    })
    .catch(errors => handlerGetList({ status: `fail`, data: errors }))
}

export default getTemplatesList
